<template>
    <div class="lpcategory-card">
        <div class="header">
            <img
                class="banner"
                :src="lpCategoryIn.file.path"
                :alt="lpCategoryIn.name + ' banner'" />
            <div class="title-wrapper">
                <h4 class="title">{{ lpCategoryIn.name }}</h4>
            </div>
        </div>
        <div class="body">
            <div class="short-description">
                <design-2021-apprentice-display-html-component
                    :html-content="lpCategoryIn.description | editor_text_preview(20)">
                </design-2021-apprentice-display-html-component>
            </div>
            <div class="assignments">
                <ul
                    class="list-unstyled assignments-list"
                    v-if="getRandomAssignments">
                    <h4 class="header-title">
                        {{ $t('learning_path.exercises') }}
                    </h4>
                    <li
                        class="assignment"
                        v-for="assignment of getRandomAssignments">
                        {{ assignment.name }}
                    </li>
                </ul>
                <div class="read-more btn-after-long-arrow-icon">
                    {{ $t('learning_path.more_information') }}
                </div>
            </div>
        </div>
        <a
            class="clickable"
            :href="lpCategoryLink()"></a>
    </div>
</template>

<script>
export default {
    name: 'design-2021-learning-path-category-overview-card-component',
    props: ['lpCategoryIn', 'lpDeadlineIdIn'],
    data() {
        return {
            assignments: this.lpCategoryIn.lp_assignments ? this.lpCategoryIn.lp_assignments : [],
        };
    },
    methods: {
        lpCategoryLink() {
            return this.routes.lpCategory(this.lpDeadlineIdIn, this.lpCategoryIn.id);
        },
    },
    computed: {
        getRandomAssignments() {
            if (this.assignments.length) {
                for (let index = this.assignments.length - 1; index > 0; index--) {
                    let needle = Math.floor(Math.random() * (index + 1));
                    let tempArray = this.assignments[index];
                    this.assignments[index] = this.assignments[needle];
                    this.assignments[needle] = tempArray;
                }

                return this.assignments.slice(0, 3);
            }

            return [];
        },
    },
};
</script>

<style scoped lang="scss">
.lpcategory-card {
    position: relative;
    display: flex;
    flex-direction: column;
    height: 100%;
    margin-bottom: $grid-gutter-width;
    border-radius: 12px;

    &:hover {
        box-shadow:
            0 3px 21px 0 rgba($black, 10%),
            0 1px 8px 0 rgba($black, 5%);

        .header {
            img {
                filter: grayscale(0.5);
            }
        }
    }
}

.header {
    position: relative;

    img {
        height: 150px;
        width: 100%;
        object-fit: cover;
        object-position: center;
        border-top-left-radius: 12px;
        border-top-right-radius: 12px;
    }

    .title-wrapper {
        position: absolute;
        bottom: 0;
        background-color: rgba($primary-background-color, 0.54);
        padding: map-get($grid-gutter-spacing, 'ten') map-get($grid-gutter-spacing, 'fifteen');
        width: 100%;

        .title {
            color: $white;
            margin: 0;
        }
    }
}

.body {
    display: flex;
    flex-direction: column;
    background-color: $white;
    padding: map-get($grid-gutter-spacing, 'fifteen');
    font-size: $default-font-size;
    border-bottom-left-radius: 12px;
    border-bottom-right-radius: 12px;
    height: 100%;

    .assignments {
        flex: 1;
        display: flex;
        flex-direction: column;
    }

    .short-description {
        margin-bottom: map-get($grid-gutter-spacing, 'twenty-one');
        color: $text-muted-color;
    }

    .assignments-list {
        margin-bottom: $grid-gutter-width;
    }

    .header-title {
        color: $primary;
        margin-bottom: 0;
    }

    .assignment {
        padding: map-get($grid-gutter-spacing, 'eight') 0;
        border-bottom: 1px solid $border-color;
        font-weight: $font-weight-bold;
    }

    .read-more {
        justify-content: flex-end;
        color: $primary;
        font-weight: $font-weight-bold;
        margin-top: auto;

        &:after {
            font-size: $base-font-size;
        }
    }
}

.read-more {
    margin-top: $grid-gutter-width;
}

@media (min-width: map-get($grid-breakpoints, 'md')) {
    .body {
        .short-description {
            height: 90px;
        }
    }
}
</style>
